import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [playerData, setPlayerData] = useState(null);
  const location = useLocation();

  // Load player data from sessionStorage
  useEffect(() => {
    const loadPlayerData = () => {
      const savedPlayer = sessionStorage.getItem('currentPlayer');
      if (savedPlayer) {
        try {
          setPlayerData(JSON.parse(savedPlayer));
        } catch (e) {
          console.error('Error parsing player data', e);
        }
      }
    };
    
    // Load on mount
    loadPlayerData();
    
    // Set up listener for sessionStorage changes
    const handleStorageChange = () => {
      loadPlayerData();
    };
    
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuIsOpen(!menuIsOpen);
  };

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
      <div className="container">
        <nav className="nav">
          <Link to="/" className="nav__logo">
            <img src="/images/logo-new.svg" alt="Crazy Monkey" />
            <span>Crazy Monkey</span>
          </Link>
          
          <div className={`nav__menu ${menuIsOpen ? 'nav__menu--open' : ''}`}>
  <Link to="/" className={`nav__link ${location.pathname === '/' ? 'active' : ''}`}>
    <span className="nav__icon">🏠</span>
    Home
  </Link>
  <Link to="/games" className={`nav__link ${location.pathname === '/games' ? 'active' : ''}`}>
    <span className="nav__icon">🎮</span>
    Games
  </Link>
  <Link to="/contact" className={`nav__link ${location.pathname === '/contact' ? 'active' : ''}`}>
    <span className="nav__icon">📞</span>
    Contact
  </Link>
</div>

          
          <div className="nav__user-area">
            {playerData && (
              <div className="nav__balance">
                <span className="nav__balance-icon">🪙</span>
                <span className="nav__balance-amount">{playerData.coins.toLocaleString()}</span>
              </div>
            )}
            
            <button className="nav__menu-button" onClick={toggleMenu}>
              <img src="/images/menu-icon.svg" alt="Menu" />
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Navigation;